import axios, { AxiosError } from 'axios';
import { CONFIG } from '../config';
import { ApiError, handleError } from '../error/error';
import { authService } from '../authServices';

// Centralized Axios configuration
const axiosConfig = {
  baseURL: CONFIG.urls.apiEndpoint,
  headers: {
    "Content-Type": "application/json",
  },
};

// Axios Instances
export const apiClient = axios.create(axiosConfig);
export const apiClientFile = axios.create({
  ...axiosConfig,
  headers: {
    'Content-Type': 'multipart/form-data',
    'Accept': "application/json",
  },
});
export const apiClientNoToken = axios.create(axiosConfig);

// Axios instance
export const apiClientDowloadXL = axios.create({
  baseURL: axios.defaults.baseURL,
  headers: {
    "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  },
});



apiClientDowloadXL.interceptors.request.use((config) => {
  //if (token) {
    config.maxBodyLength=Infinity;
   // config.headers.Authorization = `Bearer ${token}`;
    config.responseType='blob';
  //}
  return config;
});

// Request Interceptor with Token Expiration Check
const addAuthorizationHeader = async (config: any) => {

  // Exclude certain endpoints (e.g., login, refresh token) from token checksconfig.url?.includes('/auth/refresh')
  if (CONFIG.urls.getLoginUrl() || CONFIG.urls.getLogoutUrl() ||CONFIG.urls.getResetPasswordUrl()  || CONFIG.urls.getResetPasswordThankYouUrl()||CONFIG.urls.getResetPasswordCompletedUrl() ) {
    const token = authService.getRawToken()||'';
   if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  }

  if (authService.isTokenExpired()) {
    const refreshed = '';//await refreshAuthToken();
    if (!refreshed) {
      // Handle token refresh failure (clear storage and redirect to login)
      authService.clearToken();
      window.location.href = CONFIG.urls.getLoginUrl();
      throw new Error('Session expired. Redirecting to login...');
    }
  }

  const token = authService.getRawToken()||'';
  if (token) config.headers.Authorization = `Bearer ${token}`;

//console.log('----',authService.getRawToken()) ;

  return config;
};


// Response Interceptor
const responseInterceptor = (error: AxiosError) => {
  if (error.response) {
    const responseData = error.response.data as { message?: string };
    const serverMessage = responseData?.message;

    if (error.response.status === 401) {
      console.warn("Unauthorized access detected. Logging out...");
      const token = authService.getRawToken()||'';
      if (token){
        authService.clearToken();
        window.location.href = CONFIG.urls.getLogoutUrl(); // Redirect after logout
      }
     
    } else {
      const apiError = new ApiError(
        serverMessage || 'An API error occurred',
        error.response.status
      );
      handleError(apiError);
    }
  } else if (error.request) {
    handleError(new ApiError('No response from server', 0));
  } else {
    handleError(new Error(error.message));
  }

  return Promise.reject(error);
};


// Attach Interceptors
const attachInterceptors = (axiosInstance: any) => {
  axiosInstance.interceptors.request.use(addAuthorizationHeader);
  axiosInstance.interceptors.response.use(
    (response: any) => response,
    (error: AxiosError<unknown, any>) => responseInterceptor(error)
  );
};

attachInterceptors(apiClient);
attachInterceptors(apiClientFile);
attachInterceptors(apiClientNoToken);
